import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import styles from './version-history-list-skeleton.module.scss';

interface VersionHistorySkeletonProps {
  count?: number;
}

export function VersionHistoryListSkeleton({count = 9}: VersionHistorySkeletonProps): ReactElement {
  const skeletonItems = [];

  for (let i = 0; i < count; i++) {
    skeletonItems.push(
      <li key={`skeleton-${i}`} className={`spacing-p-0 ${styles.versionItemSkeleton}`}>
        <div className={`flexbox flex-items-start ${styles.versionItemContent}`}>
          <div className="spacing-p-t-2">
            <div className={`flexbox flex-center _position-relative ${styles.versionIconWrapper}`}>
              <SkeletonBrick theme={SkeletonBrickTheme.LIGHT} height={24} width={24} radius="50%" isPulsating={true} />
            </div>
          </div>
          <div className={`flexbox flex-column-justify-start flex-items-start ${styles.versionContent}`}>
            <div className={`flexbox flex-items-center _full-width`}>
              <SkeletonBrick theme={SkeletonBrickTheme.LIGHT} height={21} width={210} isPulsating={true} className={styles.skeletonTextLine} />
            </div>
            <div className={`flexbox flex-items-center _full-width`}>
              <SkeletonBrick theme={SkeletonBrickTheme.LIGHT} height={18} width={76} isPulsating={true} className={styles.skeletonTextLine} />
            </div>
          </div>
        </div>
      </li>
    );
  }

  return <>{skeletonItems}</>;
}
